import React from "react";
import PropTypes from "prop-types";
// I18n
import { useTranslation } from "react-i18next";
import { Grid, Paper, Typography, Button } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import "date-fns";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";

// components
import Confirmation from "../../../../components/Confirmation";
import SectionHead from "../../../../components/SectionHead";
import Styles from "./style";
import LastPunchStatus from "components/LastPunchStatus";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { SET_EMPTY } from "config";

export const AddEditPTOView = (props) => {
  const classes = Styles();
  const { t } = useTranslation();
  const { user, pageTitle, workers, employeeChange } = props;
  const { activityStartDate, activityStartDateChange } = props;
  const { activityStartTime, activityStartTimeChange } = props;
  const { activityEndDate, activityEndDateChange } = props;
  const { activityEndTime, activityEndTimeChange } = props;
  const { saveHandler, cancelHandler } = props;
  const {
    confirmationMsg,
    closeModalConfirmationMsg,
    confirmationMsgText,
    confirmationTitleText,
  } = props;

  const { back, disableSave } = props;
  const { lastPunch } = props;

  return (
    <>
      <Grid container direction="row" justify="center">
        <Grid item sm={7} xs={12}>
          <Paper elevation={3} className={classes.card}>
            <SectionHead back={back} name={pageTitle} />
            {!workers && user && (user.firstName || user.lastName) && (
              <Grid container direction="row">
                <Grid item xs={9}>
                  <Typography
                    variant="h6"
                    color="primary"
                    className={classes.username}
                  >
                    {user.lastName}, {user.firstName}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <LastPunchStatus lastPunch={lastPunch}></LastPunchStatus>
                </Grid>
              </Grid>
            )}

            {workers && (
              <Grid container direction="row">
                <Grid item xs={6} sm={6}>
                  <FormControl className={classes.formControl}>
                    <Autocomplete
                      options={workers}
                      getOptionLabel={(option) =>
                        option && (option.firstName || option.lastName)
                          ? option.firstName + " " + option.lastName
                          : SET_EMPTY
                      }
                      id="employeeSearch"
                      disableClearable
                      classes={{ inputRoot: classes.color }}
                      size="small"
                      InputProps={{ className: classes.color }}
                      onChange={employeeChange}
                      defaultValue={workers[0]}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("other.lblWorker")}
                          FormHelperTextProps={{
                            className: classes.formHelperText,
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            )}

            {/* activity start date and time */}
            <Grid container direction="row">
              <Grid item xs={12} sm={6} md={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableBackdropClick
                    margin="normal"
                    id="date-picker-dialog"
                    label={t("pgAddEditPTOSupervisor.lblStartDate")}
                    format="MM/dd/yyyy"
                    value={activityStartDate}
                    onChange={activityStartDateChange}
                    minDate={moment().day(-14)}
                    maxDate={moment().day(20)}
                    KeyboardButtonProps={{
                      "aria-label": "Select Punch Date",
                    }}
                    className={classes.formControl}
                    invalidDateMessage={t(
                      "pgAddEditPunchSupervisor.lblInvalidDate"
                    )}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    ampm={false}
                    disableBackdropClick
                    margin="normal"
                    id="time-picker"
                    label={t("pgAddEditPTOSupervisor.lblStartTime")}
                    value={activityStartTime}
                    onChange={activityStartTimeChange}
                    KeyboardButtonProps={{
                      "aria-label": "Select Punch Time",
                    }}
                    className={classes.formControl}
                    invalidDateMessage={t(
                      "pgAddEditPunchSupervisor.lblInvalidTime"
                    )}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>

            {/* activity end date and time */}
            <Grid container direction="row">
              <Grid item xs={12} sm={6} md={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableBackdropClick
                    margin="normal"
                    id="date-picker-dialog"
                    label={t("pgAddEditPTOSupervisor.lblEndDate")}
                    format="MM/dd/yyyy"
                    value={activityEndDate}
                    onChange={activityEndDateChange}
                    minDate={new Date(activityStartDate)}
                    maxDate={moment().day(20)}
                    KeyboardButtonProps={{
                      "aria-label": "Select Punch Date",
                    }}
                    minDateMessage={t("pgPunch.minDateErrorMessage")}
                    className={classes.formControl}
                    invalidDateMessage={t(
                      "pgAddEditPunchSupervisor.lblInvalidDate"
                    )}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    ampm={false}
                    disableBackdropClick
                    margin="normal"
                    id="time-picker"
                    label={t("pgAddEditPTOSupervisor.lblEndTime")}
                    value={activityEndTime}
                    onChange={activityEndTimeChange}
                    KeyboardButtonProps={{
                      "aria-label": "Select Punch Time",
                    }}
                    className={classes.formControl}
                    invalidDateMessage={t(
                      "pgAddEditPunchSupervisor.lblInvalidTime"
                    )}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>

            {/* save and cancel buttons */}
            <Grid container direction="row" justify="flex-end">
              <Grid item>
                <Button
                  color="primary"
                  onClick={cancelHandler}
                  className={classes.button}
                >
                  {t("general.cancelBtn")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={saveHandler}
                  className={classes.button}
                  disabled={disableSave}
                >
                  {t("general.saveBtn")}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Confirmation
        confirmationMsg={confirmationMsg}
        closeModalConfirmationMsg={closeModalConfirmationMsg}
        confirmationMsgText={confirmationMsgText}
        confirmationTitleText={confirmationTitleText}
      />
    </>
  );
};

AddEditPTOView.propTypes = {
  user: PropTypes.object,
  pageTitle: PropTypes.string,
  workers: PropTypes.object,
  employeeChange: PropTypes.func,
  punch: PropTypes.any,
  punchOptions: PropTypes.any,
  punchChange: PropTypes.func,
  activityStartDate: PropTypes.any,
  activityStartDateChange: PropTypes.any,
  activityStartTime: PropTypes.any,
  activityStartTimeChange: PropTypes.any,
  activityEndDate: PropTypes.any,
  activityEndDateChange: PropTypes.func,
  activityEndTime: PropTypes.any,
  activityEndTimeChange: PropTypes.func,
  saveHandler: PropTypes.func,
  cancelHandler: PropTypes.func,
  confirmationMsg: PropTypes.any,
  closeModalConfirmationMsg: PropTypes.any,
  confirmationMsgText: PropTypes.any,
  confirmationTitleText: PropTypes.any,
  back: PropTypes.func,
  disableSave: PropTypes.bool,
  lastPunch: PropTypes.any,
};

export default AddEditPTOView;
